const SERVICES_TRIGGER_SELECTOR = '[data-cheope-services-trigger]';

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest(SERVICES_TRIGGER_SELECTOR);
  if (!(trigger instanceof HTMLButtonElement)) return;

  const menuItem = trigger.closest('.menu-list__list-item');
  const disclosure = menuItem?.querySelector('[data-cheope-services-disclosure]');
  if (!(disclosure instanceof HTMLButtonElement)) return;

  event.preventDefault();
  disclosure.click();

  requestAnimationFrame(() => {
    trigger.setAttribute('aria-expanded', disclosure.getAttribute('aria-expanded') || 'false');
  });
});
